import { useEffect, useState, useRef } from "react";
import { DateBox, TextBox, LoadPanel } from "devextreme-react";
import axios from "axios";
import { handleGetLocal } from "../../../services/auth-service";
import { DynamicTabb } from "../../../components/DynamicTab/DynamicTab";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import "./DischargeDateCalculator.css";
import { getDateBoxFormat } from "../../Dateapi/dateFormatter";

const DischargeDateCalculator = ({ visible, onClose }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalDays, setTotalDays] = useState(null);
  const [daysRevoked, setDaysRevoked] = useState(null);
  const [daysServed, setDaysServed] = useState(null);
  const [oldDischargeDate, setOldDischargeDate] = useState(null);
  const [newDischargeDate, setNewDischargeDate] = useState(null);
  const [daysToSubtract, setDaysToSubtract] = useState(null);
  const [loading, setLoading] = useState(false);

  const pathURL = handleGetLocal("pathURL");
  const userinfo = useSelector((store) => store.participate.participantdata);
  console.log("userinfo", userinfo);

  const printAreaRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: printAreaRef,
    documentTitle: "Discharge_Date_Calculator",
    removeAfterPrint: true,
  });

  const STORAGE_KEY = (id) => `ddc:${id ?? "unknown"}`;

  const readDraft = (id) => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY(id)) || "");
    } catch {
      return null;
    }
  };

  const writeDraft = (id, draft) => {
    try {
      sessionStorage.setItem(STORAGE_KEY(id), JSON.stringify(draft));
    } catch {}
  };

  const clearDraft = (id) => {
    try {
      sessionStorage.removeItem(STORAGE_KEY(id));
    } catch {}
  };

  // console.log("userinfo", userinfo);

  // Calculate total days from start/end date
  useEffect(() => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const timeDiff = end.getTime() - start.getTime();
      const diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
      setTotalDays(!isNaN(diffDays) ? diffDays : "");
    }
  }, [startDate, endDate]);

  // Load data
  // useEffect(() => {
  //   if (userinfo?.gPersonId) {
  //     axios
  //       .post(
  //         `${process.env.REACT_APP_API_URL}/api/Person/discharge-calculator`,
  //         {
  //           personId: userinfo.gPersonId,
  //           action: "load",
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //             Domain: pathURL,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         // console.log("response", res);
  //         const data = res.data;
  //         setStartDate(data.startDate ? new Date(data.startDate) : null);
  //         setEndDate(data.endDate ? new Date(data.endDate) : null);
  //         setTotalDays(data.totalDays ?? null);
  //         setDaysRevoked(data.daysRevoked ?? null);
  //         setDaysServed(data.daysServed ?? null);
  //         setDaysToSubtract(data.daysToSubtract ?? null);
  //         setOldDischargeDate(data.oldDischargeDate ? new Date(data.oldDischargeDate) : null);
  //         setNewDischargeDate(data.newDischargeDate ? new Date(data.newDischargeDate) : null);
  //       });
  //   }
  // }, []);

  useEffect(() => {
    const id = userinfo?.gPersonId;
    if (!id) return;

    const draft = readDraft(id);
    if (draft) {
      setStartDate(draft.startDate ? new Date(draft.startDate) : null);
      setEndDate(draft.endDate ? new Date(draft.endDate) : null);
      setTotalDays(draft.totalDays ?? null);
      setDaysRevoked(draft.daysRevoked ?? null);
      setDaysServed(draft.daysServed ?? null);
      setDaysToSubtract(draft.daysToSubtract ?? null);
      setOldDischargeDate(draft.oldDischargeDate ? new Date(draft.oldDischargeDate) : null);
      setNewDischargeDate(draft.newDischargeDate ? new Date(draft.newDischargeDate) : null);
      return; // don’t overwrite an in-progress draft with API data
    }

    // No draft -> load from API
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/Person/discharge-calculator`,
        {
          personId: id,
          action: "load",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: pathURL,
          },
        }
      )
      .then((res) => {
        const data = res.data;
        setStartDate(data.startDate ? new Date(data.startDate) : null);
        setEndDate(data.endDate ? new Date(data.endDate) : null);
        setTotalDays(data.totalDays ?? null);
        setDaysRevoked(data.daysRevoked ?? null);
        setDaysServed(data.daysServed ?? null);
        setDaysToSubtract(data.daysToSubtract ?? null);
        setOldDischargeDate(data.oldDischargeDate ? new Date(data.oldDischargeDate) : null);
        setNewDischargeDate(data.newDischargeDate ? new Date(data.newDischargeDate) : null);
      });
  }, [userinfo?.gPersonId, pathURL]);

  // Whenever any field changes, write to sessionStorage
  useEffect(() => {
    const id = userinfo?.gPersonId;
    if (!id) return;

    writeDraft(id, {
      startDate: startDate ? new Date(startDate).toISOString() : null,
      endDate: endDate ? new Date(endDate).toISOString() : null,
      totalDays,
      daysRevoked,
      daysServed,
      oldDischargeDate: oldDischargeDate ? new Date(oldDischargeDate).toISOString() : null,
      daysToSubtract,
      newDischargeDate: newDischargeDate ? new Date(newDischargeDate).toISOString() : null,
    });
  }, [
    userinfo?.gPersonId,
    startDate,
    endDate,
    totalDays,
    daysRevoked,
    daysServed,
    oldDischargeDate,
    daysToSubtract,
    newDischargeDate,
  ]);

  useEffect(() => {
    if (daysRevoked !== null && daysServed !== null && !isNaN(daysRevoked) && !isNaN(daysServed) && oldDischargeDate) {
      const subtract = Math.max(Number(daysRevoked) - Number(daysServed), 0);
      setDaysToSubtract(subtract);

      const newDate = new Date(oldDischargeDate);
      newDate.setDate(newDate.getDate() - subtract);
      setNewDischargeDate(newDate);
    } else {
      setDaysToSubtract(0);
      setNewDischargeDate(null);
    }
  }, [daysRevoked, daysServed, oldDischargeDate]);

  return (
    <>
      <LoadPanel visible={loading} />
      {/* {visible && ( */}
      <div className="particcipentPage">
        <DynamicTabb />
        <div ref={printAreaRef} className="discharge-calculator" style={{ padding: 20 }}>
          <div className="print-only" style={{ marginBottom: "20px" }}>
            <p style={{ margin: "4px 0" }}>
              <strong>Offender Name:</strong> {userinfo?.sLastFirst}
            </p>
            <p style={{ margin: "4px 0" }}>
              <strong>Offender Number:</strong> {userinfo?.sOffenderNumber}
            </p>
          </div>
          <h4 style={{ color: "#434266" }}>USE THIS TO CALCULATE SERVED TIME IF DAYS SERVED IS UNKNOWN</h4>
          <p>
            <b>CALCULATE NUMBER OF DAYS BETWEEN TWO DATES (INCLUDES BOTH DATES IN TOTAL)</b>
          </p>
          <div style={{ display: "flex", gap: 15, marginTop: 10, alignItems: "center" }}>
            <label>Start Date:</label>
            <DateBox displayFormat={getDateBoxFormat()} value={startDate} onValueChange={setStartDate} />
            <label>End Date:</label>
            <DateBox displayFormat={getDateBoxFormat()} value={endDate} onValueChange={setEndDate} />
            <label>Total Days:</label>
            <TextBox value={totalDays ?? ""} readOnly />
          </div>

          <div style={{ marginTop: 30 }}>
            <b>CALCULATE NUMBER OF DAYS TO CREDIT OFFENDER FOR JAIL TIME</b>
            <div style={{ display: "grid", gridTemplateColumns: "0.2fr 0.2fr", gap: 20, marginTop: 15 }}>
              <div>
                <label>Enter Days Ordered Revoked:</label>
                <TextBox
                  value={daysRevoked ?? ""}
                  style={{ width: 100 }}
                  mode="number"
                  onValueChange={setDaysRevoked}
                />
              </div>
              <div>
                <label>Enter Days Actually Served:</label>
                <TextBox value={daysServed ?? ""} style={{ width: 100 }} mode="number" onValueChange={setDaysServed} />
              </div>
              <div>
                <label>Enter Old Discharge Date:</label>
                <DateBox displayFormat={getDateBoxFormat()} value={oldDischargeDate} style={{ width: 200 }} onValueChange={setOldDischargeDate} />
              </div>
              <div>
                <label>Days to Subtract from Old Discharge Date:</label>
                <TextBox value={daysToSubtract} style={{ width: 100 }} onValueChange={setDaysToSubtract} />
              </div>
              <div>
                <label>New Discharge Date:</label>
                <DateBox displayFormat={getDateBoxFormat()} value={newDischargeDate} style={{ width: 200 }} onValueChange={setNewDischargeDate} />
              </div>
            </div>
          </div>
          <div style={{ marginTop: 30, display: "flex", gap: 15 }}>
            <button className="primary_btn no-print" onClick={handlePrint}>
              Print
            </button>
            {/* <button className="primary_btn" onClick={onClose}>Close</button> */}
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default DischargeDateCalculator;
